export class HiDash {
  static isString(value) {
    return typeof value === 'string';
  }

  static serializeError(error) {
    if (error?.response) {
      const responseBody = error.response.data || error.response.body;
      return JSON.stringify(responseBody);
    }
    return JSON.stringify(error, Object.getOwnPropertyNames(error));
  }
}
